import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from '../Services/auth.service';
import { Permissions } from '../../../Enums/permission.enum';
import {
  GENERAL_ROUTE_PATH,
  PLAN_ROUTE_PATH,
  USERS_ROUTE_PATH,
} from '../Consts/billing-route.const';

export const settingsLandingGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.initializeAuth().pipe(
    map(() => {
      const user = authService.getCurrentUser();
      // General is appended last (and first in navigation-menu.component.ts) -- every org root
      // holds every catalog permission, so placing it earlier here would move all of them off /settings/users.
      const candidates: [string, Permissions][] = [
        [GENERAL_ROUTE_PATH, Permissions.GENERAL_SETTINGS_MANAGER],
        [USERS_ROUTE_PATH, Permissions.USER_MANAGER],
        [PLAN_ROUTE_PATH, Permissions.BILLING_MANAGER],
      ];

      const reachablePath = candidates.find(([, permission]) =>
        user?.hasPermission(permission),
      )?.[0];

      return router.createUrlTree([reachablePath ?? '/']);
    }),
  );
};
